// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../../../node_modules/@angular-devkit/build-angular/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../../../node_modules/@angular/material/prebuilt-themes/deeppurple-amber.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_group_modal {
  display: flex;
  flex-direction: column;
}

.input {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.input label {
  margin-bottom: 0.5rem;
}

.select_input {
  width: 100%;
}

.dropdown {
  padding: 10px;
  cursor: pointer;
  max-height: 200px;
  overflow-y: auto;
}

.notification.error {
  color: red;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.button_secondary {
  margin-left: 1rem;
}

.scrollable-modal-body {
  max-height: 750px;
  overflow-y: auto;
}

.button_grey {
  color: #000;
  background-color: #dcdcdc;
  border-color: #dcdcdc;
  border-radius: 28px;
  font-size: 14px;
  padding: 10px 20px;
}

.container {
  display: flex;
}

.left-div {
  flex: 1;
  padding-top: 10px;
}

.right-div {
  flex: 1;
  padding: 10px;
}

.opening-stm, .opening-stm-3 {
  font-size: 14px;
  color: black;
  font-weight: bold;
  padding-bottom: 3px;
}

.opening-stm-2 {
  font-size: 14px;
  color: #FF4612;
  font-weight: bold;
  padding-bottom: 3px;
}

.radio-group {
  display: flex;
  flex-direction: row;
}

mat-radio-button {
  margin: 0 20px;
}

.details-container {
  padding: 10px;
  background-color: #F7F7FC;
  border: 1px solid #f4f4f4;
  border-radius: 8px;
}

.opening-stm-3 {
  padding-top: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  width: 80%;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-height: 80vh;
  overflow-y: auto;
}

.table-container {
  width: 100%;
  max-height: 296px;
  overflow: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

.container-btn {
  display: flex;
  width: 100%;
}

.text-container {
  width: 70%;
  padding: 10px;
}

.button-container {
  width: 30%;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.other-pill, .end-pill {
  background-color: #e9432a;
  color: white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e9432a;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  margin-bottom: 7px;
}

.end-pill {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-bottom: 12px;
}

button.end-pill.disabled {
  background-color: gray;
  color: white; /* Adjust text color for better contrast */
  cursor: not-allowed; /* Optional: indicates the button is not clickable */
  opacity: 0.6; /* Optional: makes the button look visually distinct */
}

.circular-checkbox {
  display: inline-block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
}

.circular-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: -9px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ccc;
  border-radius: 50%;
}

.circular-checkbox input:checked ~ .checkmark {
  top: -7px;
  background-color: #FF4612;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.circular-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.circular-checkbox .checkmark:after {
  left: 7px;
  top: 5px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.call-stm {
  padding: 10px;
  background-color: #fdece9;
  border: 1px solid #FF4612;
  border-radius: 8px;
  color: black;
  margin-bottom: 10px;
}

.progress-cls {
  background-color: #e4e4e4;
  color: #818181;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.pending-cls, .callback-cls {
  background-color: #fdece9;
  color: #FF633E;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #fdece9;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.cls-reject {
  background-color: #f14741;
  color: white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #f14741;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.convert-cls, .assign-cls {
  background-color: #00880f;
  color: white;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #00880f;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}

.cls-accept {
  background-color: #e5f3e7;
  color: #00880f;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #e5f3e7;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  font-size: 12px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/crm/crm-upsell-eligibity/crm-upsell-modal/crm-upsell-modal.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,OAAA;EACA,iBAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EAEE,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,yBAAA;AAHF;;AAKA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,UAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,yBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,UAAA;EACA,aAAA;AAAF;;AAGA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,sBAAA;EACA,YAAA,EAAA,0CAAA;EACA,mBAAA,EAAA,oDAAA;EACA,YAAA,EAAA,sDAAA;AADF;;AAIA;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,SAAA;EACA,yBAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;AAQA,w4TAAw4T","sourcesContent":["@import \"~@angular/material/prebuilt-themes/deeppurple-amber.css\";\n\n.form_group_modal {\n  display: flex;\n  flex-direction: column;\n}\n\n.input {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n}\n\n.input label {\n  margin-bottom: 0.5rem;\n}\n\n.select_input {\n  width: 100%;\n}\n\n.dropdown {\n  padding: 10px;\n  cursor: pointer;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.notification.error {\n  color: red;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n.button_secondary {\n  margin-left: 1rem;\n}\n\n.scrollable-modal-body {\n  max-height: 750px;\n  overflow-y: auto;\n}\n\n.button_grey {\n  color: #000;\n  background-color: #dcdcdc;\n  border-color: #dcdcdc;\n  border-radius: 28px;\n  font-size: 14px;\n  padding: 10px 20px;\n}\n\n\n.container {\n  display: flex;\n}\n\n.left-div {\n  flex: 1;\n  padding-top: 10px;\n}\n\n.right-div {\n  flex: 1;\n  padding: 10px;\n}\n\n.opening-stm {\n  font-size: 14px;\n  color: black;\n  font-weight: bold;\n  padding-bottom: 3px;\n}\n\n.opening-stm-2 {\n  font-size: 14px;\n  color: #FF4612;\n  font-weight: bold;\n  padding-bottom: 3px;\n}\n\n.radio-group {\n  display: flex;\n  flex-direction: row;\n}\n\nmat-radio-button {\n  margin: 0 20px; \n}\n\n\n.details-container {\n  padding: 10px;\n  background-color: #F7F7FC;\n  border: 1px solid #f4f4f4;\n  border-radius: 8px;\n}\n\n.opening-stm-3 {\n  @extend .opening-stm;\n  padding-top: 5px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\nth {\n  background-color: #f2f2f2;\n}\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  width: 80%; \n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  max-height: 80vh; \n  overflow-y: auto;\n}\n\n.table-container {\n  width: 100%;\n  max-height: 296px; \n  overflow: auto\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.container-btn {\n  display: flex;\n  width: 100%;\n}\n\n.text-container {\n  width: 70%;\n  padding: 10px;\n}\n\n.button-container {\n  width: 30%;\n  padding: 10px;\n  display: flex;\n  justify-content: flex-end; \n  align-items: center; \n}\n\n.other-pill  {\n  background-color: #e9432a;\n  color:white;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #e9432a;\n  width: fit-content;\n  margin-right: 10px;\n  margin-bottom: 7px;\n}\n\n.end-pill {\n  @extend .other-pill;\n  display: flex;\n  justify-content: center;  \n  align-items: center; \n  margin: auto;   \n  margin-bottom: 12px; \n}\n\nbutton.end-pill.disabled {\n  background-color: gray;\n  color: white; /* Adjust text color for better contrast */\n  cursor: not-allowed; /* Optional: indicates the button is not clickable */\n  opacity: 0.6; /* Optional: makes the button look visually distinct */\n}\n\n.circular-checkbox {\n  display: inline-block;\n  position: relative;\n  padding-left: 35px;\n  cursor: pointer;\n  font-size: 16px;\n  user-select: none;\n}\n\n.circular-checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  position: absolute;\n  top: -9px;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: #ccc;\n  border-radius: 50%; \n}\n\n.circular-checkbox input:checked ~ .checkmark {\n  top: -7px;\n  background-color: #FF4612;\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.circular-checkbox input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.circular-checkbox .checkmark:after {\n  left: 7px;\n  top: 5px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  transform: rotate(45deg);\n}\n\n.call-stm {\n  padding: 10px;\n  background-color: #fdece9;\n  border: 1px solid #FF4612;\n  border-radius: 8px;\n  color: black;\n  margin-bottom: 10px;\n}\n\n.progress-cls {\n  background-color: #e4e4e4;\n  color:#818181;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #e4e4e4;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.pending-cls, .callback-cls {\n  background-color: #fdece9;\n  color:#FF633E;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #fdece9;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.cls-reject {\n  background-color: #f14741;\n  color:white;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #f14741;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.convert-cls, .assign-cls {\n  background-color: #00880f;\n  color:white;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid #00880f;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.cls-accept {\n  background-color: #e5f3e7 ;\n  color:#00880f;\n  padding: 5px;\n  border-radius: 8px;\n  border: 1px solid  #e5f3e7;\n  width: fit-content;\n  margin-right: 10px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
